import { doc, onSnapshot } from 'firebase/firestore'
import React, { useState } from 'react'
import { useContext } from 'react'
import { useEffect } from 'react'
import { AuthContext } from '../context/AuthContext'
import { ChatContext } from '../context/ChatContext'
import { db } from '../firebase'

const Chats = () => {

    const [chats, setChats] = useState([])

    const {currentUser} = useContext(AuthContext)
    const {dispatch} = useContext(ChatContext)

    useEffect(() => {
        const getChats = () => {
        const unsub = onSnapshot(doc(db, "userChats", currentUser.uid), (doc) => {
            console.log("Current data: ", doc.data());
            setChats(doc.data())
        });

        return () => {
            unsub();
        };
        };

        currentUser.uid && getChats()
    }, [currentUser.uid]);

   const handleSelect = (u) => {
    dispatch({type:"CHANGE_USER", payload: u })
   };

    return (
        <div className='chats'>
            {Object.entries(chats)?.sort((a,b)=>b[1].date - a[1].date).map((chat)=>(
                <div className="userChat" key={chat[0]} onClick={ () => handleSelect(chat[1].userInfo)}>
                <img src={chat[1].userInfo.photoURL} alt="" />
                <div className="userChatInfo">
                    <span>{chat[1].userInfo.displayName}</span>
                    <p>{chat[1].lastMessage?.text}</p>
                </div>
            </div>
            ))}
        </div>
      );
}

export default Chats


// return (
//     <div className='chats'>
//         {Object.entries(chats)?.map((chat)=>(
//             <div className="userChat" key={chat[0]}>
//             <img src={chat[1].userInfo.photoURL} alt="" />
//             <div className="userChatInfo">
//                 <span>{chat[1].userInfo.displayName}</span>
//                 <p>{chat[1].userInfo.lastMessage?.text}</p>
//             </div>
//         </div>
//         ))}
//     </div>
//   );


//   return (
//     <div className='chats'>
//         <div className="userChat">
//             <img src="https://scontent-sjc3-1.xx.fbcdn.net/v/t39.30808-6/341046185_616678886659832_4411970842948082997_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=ROpbTwZq6XIAX9AXFhs&_nc_oc=AQlfnLZSpmSUaGLT03SYYHIhuTUvRmnksT-Cc_Y2o3N54N_jSV5_LLpG74u2SZpzXbw&_nc_ht=scontent-sjc3-1.xx&oh=00_AfCT9ifJhawjYn_tlEuzA2785-G3mNbYt1VQY8DHkuSHvw&oe=6444BADA" alt="" />
//             <div className="userChatInfo">
//                 <span>Sergio</span>
//                 <p>Hello</p>
//             </div>
//         </div>
//     </div>
//   )